export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,

  title: '待上架明细',
} as TCommon.RouteConfig
